import type { Place } from '@placer-ui/types';

export const isPlaceOutsourceMapPoi = (poi: Pick<Place, 'provider_data'>) => {
    return (
        poi.provider_data &&
        (poi.provider_data.provider === 'google' || poi.provider_data.provider === 'mapbox')
    );
};
